export default ({quantity = 0, name = '', itemWidth = 200}) => ({
    name: name,
    itemsQuantity: quantity,
    itemWidth,
    itemsGap: 16,
    scrolling: false,
    canScrollToLeft: false,
    canScrollToRight: false,
    isLoadingMore: false,
    loadedAll: false,
    get itemFullWidth() {
        return this.itemWidth + this.itemsGap;
    },
    getRemainingScrollToRight() {
        if (!this.$refs.carousel) {
            return 0;
        }

        const { scrollWidth, scrollLeft, clientWidth } = this.$refs.carousel;

        return Math.trunc(scrollWidth - (scrollLeft + clientWidth));
    },
    getRemainingScrollToLeft() {
        return this.$refs.carousel?.scrollLeft || 0;
    },
    getJumps() {
        const { clientWidth } = this.$refs.carousel;

        let jumps = Math.ceil(clientWidth / this.itemFullWidth);

        if ((jumps * this.itemFullWidth) - this.itemsGap > clientWidth) {
            jumps = Math.floor(clientWidth / this.itemFullWidth);
        }

        return jumps;
    },
    getWidthToScroll(jumps, remainingScroll) {
        jumps = Math.max(jumps, 1);

        return Math.min(jumps * this.itemFullWidth, remainingScroll);
    },
    updateCanScroll() {
        const el = this.$refs.carousel;

        const clientWidth = el?.clientWidth || 0;

        const largerThanContainer = clientWidth < this.itemsQuantity * this.itemFullWidth;

        this.$nextTick(() => {
            this.canScrollToLeft = this.getRemainingScrollToLeft() > 0;
            this.canScrollToRight = largerThanContainer && this.getRemainingScrollToRight() > 0;

            this.$dispatch(`carousel-${this.name}-can-scroll-left`, { canScrollToLeft: this.canScrollToLeft });
            this.$dispatch(`carousel-${this.name}-can-scroll-right`, { canScrollToRight: this.canScrollToRight });
        });
    },
    callUpdateCanScroll() {
        const el = this.$refs.carousel;

        if ('onscrollend' in window) {
            el.addEventListener('scrollend', () => {
                this.updateCanScroll();
                this.scrolling = false;
            }, { once: true });

            return
        }

        setTimeout(() => {
            this.updateCanScroll();
            this.scrolling = false;
        }, 500);
    },
    tryLoadMore(lastJumpWidth = 0) {
        const el = this.$refs.carousel;

        const shouldLoadMore = !this.loadedAll &&
            !this.isLoadingMore &&
            this.getRemainingScrollToRight() - lastJumpWidth < el.clientWidth;

        if (!shouldLoadMore) {
            return;
        }

        this.isLoadingMore = true;

        this.$dispatch('load-more');
    },
    scroll(width) {
        const el = this.$refs.carousel;
        this.scrolling = true;

        el.scrollBy({
            left: width,
            top: 0,
            behavior: 'smooth'
        });

        this.callUpdateCanScroll();

        if (width > 0) {
            this.tryLoadMore(width);
        }
    },
    showMore(direction) {
        direction = direction === 'right' ? 'right' : 'left';

        const remainingScroll = direction === 'right' ?
            this.getRemainingScrollToRight() :
            this.getRemainingScrollToLeft();

        const jumps = this.getJumps();

        let widthToScroll = this.getWidthToScroll(jumps, remainingScroll);

        widthToScroll = direction === 'right' ? widthToScroll : -widthToScroll;

        if (this.scrolling || widthToScroll === 0) {
            return;
        }

        this.scroll(widthToScroll);
    },
    handleUpdateItemsQuantity(event) {
        this.itemsQuantity = event.detail.itemsQuantity;
    },
    handleNoMoreMedias() {
        this.isLoadingMore = false;
        this.loadedAll = true;
    },
    handleScrollSelf() {
        this.tryLoadMore();
        this.updateCanScroll();
    },
    handleScrollArrow(event, direction) {
        const { name } = event.detail;

        if (name !== this.name) {
            return;
        }

        this.showMore(direction);
    },
    handleUpdatedItemWidth(event) {
        this.itemWidth = event.detail.width;
    },
    handleUpdatedGap(event) {
        this.itemsGap = event.detail.gap;

        this.$nextTick(() => {
            const fullWidth = (this.itemsQuantity * this.itemFullWidth) - this.itemsGap;
            this.canScrollToRight = this.$refs.carousel.clientWidth < fullWidth;

            this.$dispatch(`carousel-${this.name}-can-scroll-right`, {canScrollToRight: this.canScrollToRight});
        });
    },
    init() {
        this.$nextTick(() => {
            const fullWidth = (this.itemsQuantity * this.itemFullWidth) - this.itemsGap;
            this.canScrollToRight = this.$refs.carousel.clientWidth < fullWidth;

            this.$dispatch(`carousel-${this.name}-can-scroll-right`, {canScrollToRight: this.canScrollToRight});

            this.$watch('itemsQuantity', () => {
                this.isLoadingMore = false;
                this.updateCanScroll();
            });
        });
    }
})

